import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

//Give the input as the normal string. Example: Hello World
export function toKebabCase(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

//Give the input as the kebab Case. Example: hello-world
export function toNormalString(slug: string): string {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const colors = [
  "bg-red-500",
  "bg-pink-500",
  "bg-purple-500",
  "bg-blue-500",
  "bg-green-500",
  "bg-yellow-500",
  "bg-orange-500",
  "bg-indigo-500",
  "bg-rose-500",
  "bg-teal-500",
  "bg-emerald-500",
];

export function getColorByHash(name, colorArray = colors) {
  let hash = 0;
  if (name.length === 0) return colorArray[0];

  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  return colorArray[Math.abs(hash) % colorArray.length];
}

export const isUuid = (str: string | null | undefined): boolean => {
  if (!str) return false;
  // This is a canonical simple regex for UUID (lowercase/uppercase, hyphens)
  const uuidRegex =
    /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/;
  return uuidRegex.test(str);
};
